module.exports = __webpack_public_path__ + "img/edge_activites_cyclo.2c39e07e.svg";